// extracted by mini-css-extract-plugin
export default {"loaderFacet":"z5uYJqXhsxacShLjDgx1"};